import React from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import {
  Update,
  GetById,
} from "adminApi/RoomNoFloorAssign/RoomNoFloorAssign";

import { validateForm } from "utils/validation";

import {
  RoomNoFloorAssignEditRules,
} from "validation/ValidationRules";

import Spinner from "Common/Globle/Spinner";

import EditRoomNoFloorAssignForm from "./Components/EditRoomNoFloorAssignForm";

import fields from "../json/RoomNoFloorAssignFields.json";

import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const RoomNoFloorAssignEdit = () => {
  const navigate = useNavigate();

  const { id } = useParams();

  const { formdata } = fields;

  /* =======================================================
     INITIAL VALUES
  ======================================================= */

  const initialValues = formdata.reduce(
    (acc, field) => ({
      ...acc,
      [field.name]: "",
    }),
    {},
  );

  /* =======================================================
     FORM
  ======================================================= */

  const {
    values,
    errors,
    handleChange,
    setErrors,
    setValues,
  } = useFormChange(
    initialValues,
    RoomNoFloorAssignEditRules,
  );

  /* =======================================================
     FETCH DATA
  ======================================================= */

  const {
    loading: loadingFetch,
  } = useFetchFormDataById(
    id,
    formdata,
    GetById,
    setValues,
  );

  /* =======================================================
     SUBMIT
  ======================================================= */

  const {
    loading: loadingSubmit,
    handleSubmit,
  } = useFormSubmit(
    async (formValues) => {
      const payload = {
        status:
          formValues.status,
      };

      return await Update({
        id,
        data: payload,
      });
    },

    (vals) => {
      const err = validateForm(
        vals,
        RoomNoFloorAssignEditRules,
      );

      setErrors(err);

      return err;
    },

    () => navigate(-1),

    "Room floor assignment updated successfully",
  );

  return (
    <>
      {(loadingSubmit ||
        loadingFetch) && (
          <Spinner isSpinner={true} />
        )}

      <EditRoomNoFloorAssignForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) =>
          handleSubmit(e, values)
        }
        loading={loadingSubmit}
      />
    </>
  );
};

export default RoomNoFloorAssignEdit;